import { forwardRef } from 'react'

import { SENTIMENT_BORDER } from './sentimentBorder'
import type { SentimentIconProps } from './types'

const FILL = 'var(--hsds-token-color-yellow-accent, #FFB83D)'
const PATH =
  'M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6 11C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9H7.58594L5.29297 6.70703C4.90244 6.31651 4.90244 5.68349 5.29297 5.29297C5.6835 4.90249 6.31652 4.90246 6.70703 5.29297L9 7.58594V6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6V10C11 10.5523 10.5523 11 10 11H6Z'

// Declining sentiment (trend) — amber circle with a diagonal down-right arrow.
// The `border` variant renders the same glyph in a 20×20 box behind a white
// border so it reads on colored backgrounds (mirrors the Figma `Border=True` asset).
const DecliningSentimentIcon = forwardRef<SVGSVGElement, SentimentIconProps>(
  function DecliningSentimentIcon({ border = false, ...rest }, ref) {
    if (border) {
      return (
        <svg
          ref={ref}
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          {SENTIMENT_BORDER}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            transform="translate(2 2)"
            d={PATH}
            fill={FILL}
          />
        </svg>
      )
    }

    return (
      <svg
        ref={ref}
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path fillRule="evenodd" clipRule="evenodd" d={PATH} fill={FILL} />
      </svg>
    )
  }
)

export { DecliningSentimentIcon }
